import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  onIdTokenChanged,
  onAuthStateChanged,
  getIdToken,
} from "firebase/auth";

import { auth } from "../utils/firebase/firebase";
import {
  setIdToken,
  setUser,
  setUserDetails,
  unsetUser,
} from "../features/auth/authSlice";
import { getUserDetails } from "../utils/variables";

const AuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { uid, email } = useSelector((state) => state.auth);

  useEffect(() => {
    const authListener = onAuthStateChanged(
      auth,
      async (user) => {
        if (user) {
          if (!uid || !email) {
            dispatch(
              setUser({
                email: user.email,
                uid: user.uid,
              })
            );
          }

          const {
            firstName,
            lastName,
            fullName,
            address,
            contactNumber,
            dateCreated,
            memberExpiry,
            isActive,
          } = await getUserDetails(uid);

          dispatch(
            setUserDetails({
              firstName,
              lastName,
              fullName,
              dateCreated,
              memberExpiry,
              address,
              contactNumber,
              isActive,
            })
          );
        } else {
          dispatch(unsetUser());
        }
      },
      [uid]
    );

    const tokenListener = onIdTokenChanged(auth, async (user) => {
      if (user) {
        const idToken = await getIdToken(user);
        // console.log("idToken", idToken);
        dispatch(setIdToken(idToken));
      } else {
        dispatch(setIdToken(""));
      }
    });

    return () => {
      authListener();
      tokenListener();
    };
  }, [dispatch, uid, email]);

  return <>{children}</>;
};

export default AuthProvider;
